export default {
    PENDING: 3,
    REJECTED: 4,
    ACTIVE: 2,
}